export type Intent = string; // e.g. "wishlist:abc123" | "book:abc123"

export function safeReturnTo(raw: string | null | undefined, fallback = "/home"): string {
  if (!raw) return fallback;
  let value = raw;
  try {
    value = decodeURIComponent(raw);
  } catch {
    return fallback;
  }
  if (!value.startsWith("/")) return fallback;
  if (value.startsWith("//") || value.startsWith("/\\")) return fallback;
  return value;
}

export function loginUrlWithIntent(pathname: string, search: string, intent?: Intent): string {
  const params = new URLSearchParams(search);
  if (intent) params.set("intent", intent);
  const query = params.toString();
  const returnTo = query ? `${pathname}?${query}` : pathname;
  return `/login?returnTo=${encodeURIComponent(returnTo)}`;
}

export function intentFromReturnTo(returnTo: string | null | undefined): Intent | null {
  if (!returnTo) return null;
  const q = returnTo.split("?")[1];
  if (!q) return null;
  return new URLSearchParams(q).get("intent");
}

export function parseIntent(intent: string | null): { verb: string; id: string } | null {
  if (!intent) return null;
  const [verb, id = ""] = intent.split(":");
  if (!verb) return null;
  return { verb, id };
}

export function intentMessage(intent: string | null): string | null {
  const parsed = parseIntent(intent);
  if (!parsed) return null;
  if (parsed.verb === "book") return "Please log in to book this property.";
  if (parsed.verb === "wishlist") return "Please log in to save this property to your wishlist.";
  return "Please log in to continue.";
}